import React from 'react';
import { Icon } from 'antd';
import Btn, { btnTypes } from '../../../../../../components/btn';
import { paths } from '../../../../shared/configs/routing';
import styles from './index.module.scss';

const ToCreateAcceptance = () => {
  return (
    <Btn
      className={styles.root}
      type={btnTypes.primary}
      to={(location) => ({
        pathname: paths.create,
        state: { from: { location } },
      })}
    >
      <span>Создать новый прием помещений</span>
      <Icon type="plus-circle" style={{ fontSize: '14px', height: '14px' }} />
    </Btn>
  );
};

export default ToCreateAcceptance;
